<script>
export default {
  props: {
    entry: {
      type: Object,
      required: true,
    },
  },
}
</script>

<template>
  <!-- Article meta -->
  <div class="flex items-center my-6">
    <div class="flex shrink-0 mr-3">
      <a class="relative" href="#0">
        <span class="absolute inset-0 -m-px" aria-hidden="true"
          ><span class="absolute inset-0 -m-px bg-white rounded-full"></span
        ></span>
        <img
          class="relative rounded-full"
          :src="entry.fields.author.fields.profileImage.fields.file.url"
          width="32"
          height="32"
          alt="Author 04"
        />
      </a>
    </div>
    <div>
      <span class="text-gray-600">Par </span>
      <a class="font-medium hover:underline" href="#0">{{
        entry.fields.author.fields.fullName
      }}</a>
      <span class="text-gray-600">
        · 2024
        <!--{{ entry.fields.lastUpdated }}-->
      </span>
    </div>
  </div>
</template>
